// import Plyr from 'plyr';
const Plyr = () => import(
    /* webpackChunkName: "module-plyr" */ 'plyr'
    )
import {gsap} from "gsap";

const MODAL_TRANSLATIONS = {
    fr: {
        close: 'Fermer'
    },
    en: {
        close: 'Close'
    },
    de: {
        close: 'Schließen'
    }
}

export const init = () => {
    bindEvents()
}

/**
 * Display form logic
 */
const bindEvents = () => {
    document.addEventListener('click', (event) =>
    {
        const closest = event.target.closest('[data-video]')
        if (closest) {

            event.preventDefault()
            event.stopPropagation()
            event.stopImmediatePropagation()
            const btn = closest
            btn.classList.add('video--loading')

            const videoData = JSON.parse(closest.dataset.video)

            if (typeof videoData !== 'object') return

            const modal = document.createElement('div')
            // modal.id = 'player-'+videoId
            modal.classList.add('block-modal','modal-player')
            modal.style.display = 'none'

            modal.innerHTML = `
                <div class="container">
                    <div class="block-modal__container is-video">
                        <button data-close-modal class="btn btn--icon btn--white">
                            <i class="app-icon app-icon-close app-icon--sm"></i>
                        </button>
                    </div>
                </div>
            `

            let playerDiv

            if (videoData.provider && videoData.id)
            {
                playerDiv = document.createElement('div')
                playerDiv.setAttribute('data-plyr-embed-id', videoData.id)
                playerDiv.setAttribute('data-plyr-provider', videoData.provider)
            }
            else if (videoData.url && videoData.mime)
            {
                playerDiv = document.createElement('video')
                const source = document.createElement("source")
                source.type = videoData.mime
                source.src = videoData.url
                playerDiv.appendChild(source)
            }

            modal.firstElementChild.firstElementChild.appendChild(playerDiv)
            document.body.appendChild(modal)
            bindModalEvents(modal)

            Plyr().then((module) => {
                const player = new module.default(playerDiv)
                player.on('ready', event => {
                    gsap.set(modal, {display: null})
                    gsap.fromTo(modal, {opacity: 0, duration: .5}, {opacity: 1})
                    btn.classList.remove('video--loading')
                    player.play()
                })
            })
        }
    })
}

const bindModalEvents = (modal) => {
    modal.addEventListener('click', (event) => {
        if (event.target.closest('.block-modal__container')) {
            event.stopPropagation()
            event.stopImmediatePropagation()
        } else {
            closeModal(modal)
        }
    })
    const close = modal.querySelector('[data-close-modal]')
    close.addEventListener('click', (event) => {
        event.stopPropagation()
        event.stopImmediatePropagation()
        event.preventDefault()
        closeModal(modal)
    })
}

const closeModal = (modal) => {
    gsap.fromTo(modal, {
        opacity: 1,
        duration: .5,
    }, {
        opacity: 0,
        onComplete: function () {
            modal.remove()
        }
    })
}
